var map = {
	"./en/translation.json": 24424,
	"./es/translation.json": 81079,
	"./fr/translation.json": 19659,
	"./jp/translation.json": 69705,
	"./kr/translation.json": 32686,
	"./pt/translation.json": 75147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80259;